var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 你已进入无人之地。 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }